module.exports = __webpack_public_path__ + "img/Sumitomo.c1d1941e.jpg";